
<template>
	<v-card outlined style="height: 100%">
            <!-- v-if="currentUser && $router.currentRoute.name=='st'" -->
       	<v-fab-transition>
		<v-btn 
			x-small             
            fab
            absolute
            right
            class="mt-0 ml-4"
            @click="btn_stream = !btn_stream"
            :color="btn_stream ? 'error' : 'primary'" 
        >
            <v-icon x-small 
              v-show="!btn_stream">mdi-plus</v-icon>
            <v-icon x-small             
              v-show="btn_stream">mdi-close</v-icon>
        </v-btn>
    	</v-fab-transition>
        <grid-layout :layout.sync="layout"
            :margin="[0, 0]"		            
            :col-num="120"
            :row-height="20"
            :is-draggable="grid_options.draggable"
            :is-resizable="grid_options.resizable"
            :vertical-compact="grid_options.vertical_compact"
            :prevent-collision="grid_options.prevent_collision"
            :use-css-transforms="true"
            :responsive="grid_options.responsive"

    	>
       		<grid-item v-for="(item, index) in layout"                  
               :x="item.x"
               :y="item.y"
               :w="item.w"
               :h="item.h"
               :i="item.i"
               :minH="item.minH"
               :minW="item.minW"
               :static="item.static"
               :key="item.i"
               	drag-allow-from=".vue-draggable-handle"
	        	drag-ignore-from=".no-drag"
               @moved="movedEvent"
               style="background: grey;"
               :maxRows="1"
            >
				<component 
					v-if="item.stream_data"
					:is 				= "item.component"  
					:id_stream 			= "item.stream_data.host_id"
					:host				= "item.stream_data.host"
					:hostname 			= "item.stream_data.hostname"
					:show_host 			= "item.stream_data.show_host_id"
					:name 				= "item.stream_data.name"
					:type 				= "item.stream_data.type"
					:layout_id 			= "item.Id"
					:host_ip 			= "item.stream_data.ip"
					:info_stream 		= "item.stream_data.info_cam"
					:is_analytic 		= "item.stream_data.name_analytic"
					v-on:close_component ="del_draw($event)"
					v-on:to_streaming 	= "change_stream_type($event, 'stream')"
					@to_analytic 		= "change_stream_type($event, 'analytic')"
					@select_device 		= "change_stream($event)"
				></component>
        	</grid-item>
        	

    	</grid-layout>
		<v-navigation-drawer
	        v-model="btn_stream"
	        :value="true"
	        right					        				        
	        absolute
	        dark
	        fixed
	        temporary
	        v-show="btn_stream"
	      >

		     <v-btn-toggle v-show="false">
		     	<template v-for =" (item_btn, idx_btn) of option_btn"

		     	>		     		
			     	<v-btn
			     		v-show="item_btn.enable"
			     		:key="idx_btn"
			     		small
			     		@click="actions(item_btn.action)"
			     	>
				     	<v-icon
				     		small
				     		v-text="item_btn.icon"
				     	></v-icon> 		
			     	</v-btn>
		     	</template>
		     </v-btn-toggle>		      
		     
		  		 <v-divider></v-divider>


		      <v-list dense flat> <!-- video streams -->
		      	<v-list-group>
				        <template v-slot:activator>
				        	<v-list-item-icon class="pa-0 mx-0 mr-1 " >
				        		<v-icon> mdi-cctv</v-icon>
				        	</v-list-item-icon>
				          <v-list-item-title v-text="$ml.get('video_streams')"></v-list-item-title>
				        </template>

		      	<v-list-item-group dense>

				<v-list dense flat>
					<v-list-group class="ml-5" dense>
				        <template v-slot:activator>
				        	<v-list-item-icon class="pa-0 mx-0 mr-1 " >
				        		<v-icon small> mdi-video-box</v-icon>
				        	</v-list-item-icon>
				        	<v-list-item-content>
				          <v-list-item-title class="text-uppercase">{{ setting_dashboard.type_stream }}</v-list-item-title>
				          <v-list-item-subtitle class="text-capitalize caption"> {{ setting_dashboard.type_analytic }}</v-list-item-subtitle>
				      </v-list-item-content>
				        </template>
				        <v-list-item 
					        v-for="(item_stream_udp, index) in list" 
					        v-if="item_stream_udp.name && item_stream_udp!==undefined"	
					        class="pl-8"
					        :key="index"
				        	@click="add_stream(item_stream_udp,  setting_dashboard.type_stream, setting_dashboard.type_analytic )"
				        	dense
				        >
				        	<!-- :three-line="text_length(item_stream_udp.name)" -->
		      		<v-list-item-icon class="pa-0 mx-0 mr-1 "   >
		      			<v-icon small>mdi-camera-metering-matrix</v-icon>
		      		</v-list-item-icon>
		      		<v-list-item-content>
		      			<v-list-item-title class="caption mb-0" style="height:15px"> {{$ml.get('device') }}: {{ item_stream_udp.id}}</v-list-item-title>
		              <v-list-item-subtitle class="caption d-flex" style="max-width:145px"> {{ item_stream_udp.name}}</v-list-item-subtitle>				              
		            </v-list-item-content>
		      	</v-list-item>
				    <!-- </v-list-group> -->
				</v-list-group>
			</v-list>
			
		     	 </v-list-item-group>
		  		</v-list-group>
		      </v-list>

		  </v-navigation-drawer>
 

    <v-dialog v-model="dialog_create_dashboard" width="500">
		<v-card outlined>
			<v-card-title 				
				class="justify-center pa-0 grey black--text caption"
			>
				<span v-if="is_new_dashboard=='dashboard'">{{ $ml.get('create_dashboard') }}</span>
				<span v-else-if="is_new_dashboard=='profile'">{{ $ml.get('create_dashboard_profile') }}</span>
				<span v-else-if="is_new_dashboard=='update'">
					{{ $ml.get('update_profile') }}
				</span>
			</v-card-title>
			<v-divider></v-divider>
			<v-card-text>
				<p class="caption mb-0"> 
					<span v-if="is_new_dashboard=='update'">
						{{ $ml.get('ms_rename_dashboard') }}
					</span>
					<span v-else>
					{{$ml.get('ms_new_dashboard')}}						
					</span>
				</p>
				<v-text-field
					type="text"
					:label="$ml.get('name')"
					v-model="name_dashboard"
					outlined dense
					hide-details
				></v-text-field>
			</v-card-text>
			<v-divider></v-divider>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn
					small
					color="primary"
					v-text="$ml.get('update')"
					@click="create_dashboard(is_new_dashboard)"
					v-if="is_new_dashboard=='update'"
				></v-btn>
					<!-- :disabled="!name_dashboard ? true : false" -->
				<v-btn
					small
					color="primary"
					v-text="$ml.get('confirm')"
					:disabled="!name_dashboard ? true : false"
					@click="create_dashboard(is_new_dashboard)"
					v-else
				></v-btn>
				<v-btn 
					small
					color="error"
					v-text="$ml.get('close')"
					@click="dialog_create_dashboard=false"
				></v-btn>
			</v-card-actions>
		</v-card>
    </v-dialog>
    <v-snackbar
    	v-model="snackbar"
    	:color="color"
    	:timeout="6000"
    	top right
    >
    	{{info}}
    	<v-btn 
    		small
    		color="error"
    		icon
    		@click="snackbar=false"
    	>
    		<v-icon small class="ml-1">mdi-close</v-icon>
    	</v-btn>
	</v-snackbar>

	<v-dialog
			v-model="dialog_option_comp"
			width="500"
		>
			<v-card outlined>
				<v-card-title
					class="caption  pa-0 primary"
				>
					<v-icon
						x-small
						v-text="'mdi-cog'"
						class="mx-2"
					></v-icon>
					<span v-text="$ml.get('settings')"></span>
					<v-spacer></v-spacer>
					<v-btn
						color="error"
						x-small
						@click="dialog_option_comp = false"
					>
						<v-icon
							x-small
							v-text="'mdi-close'"
						></v-icon>
					</v-btn>
				</v-card-title>
				<v-card-text>
					<v-row>
						<template v-for="(item_option, idx_option) of option_setting">							
							<v-col md="6">
								<v-select
									outlined
									dense
									hide-details
									:label="item_option.text"
									:items="item_option.list"
									v-model="setting_dashboard[item_option.key]"
									@input = "actions(item_option.key)"
								></v-select>
							</v-col>
						</template>
					</v-row>					
				</v-card-text>
				<v-divider></v-divider>
				<v-card-actions>
					<v-spacer></v-spacer>
					<v-btn
						x-small
						color = "primary"
						v-text="$ml.get('save')"
						@click="save_local('setting_streaming')"
					></v-btn>
				</v-card-actions>
			</v-card>
		</v-dialog>
	</v-card>
</template>
<style scoped>
	.vue-draggable-handle{

	}

  .vue-grid-item>>>.vue-resizable-handle{ /* /deep/ */
    background-color: #9c8888; /* white #047dc3*/
   /* filter: grayscale(100%);*/ 
    /*filter: invert(100%);*/
    opacity:0.5;
    width:10px;
    height: 10px;
    /*filter: brightness(0.5);*/
   filter: hue-rotate(180deg); 
    /*filter: opacity(50%); */
  }
</style>
<script>
	import graphics from '@/components/info/graphics.vue'
	import axios from 'axios'
	import EventBus from '@/event-bus';
	import VueGridLayout from 'vue-grid-layout';
	// import mapview from '@/components/mapview.vue'
	import cam from '@/components/cam.vue'
	import analytic_list from '@/components/analytics/analytics_default.json'
	import events from '@/components/events/events.vue'
	import cam_test from '@/components/cam_test.vue'
	// import constellation from '@/components/constellations/constellation.vue'
	import blank_component from '@/components/dashboard/blank_component.vue'

	export default{
		name: 'Streamings',
		components:{
			GridLayout: VueGridLayout.GridLayout,
           	GridItem: VueGridLayout.GridItem, 
           	graphics,
           	cam,
			/*mapview*/
			events,
			cam_test,
			// constellation,
			blank_component,
		}, // compnenets
		props:[],
		data: (vm) => ({
			layout: [],
			grid_options:
				{
					draggable: false,
					resizable: true,
					vertical_compact: false,
					prevent_collision: false,
					responsive: false,
				},
			list_components:{ },
			components:
				[
					'events', 
					// 'constellation'
					/*
					'rfid', 
					'match_history', 
					'mapview', 
					'alerts'*/
				],
			list:[],
			list_rtsp: [],
			dialog: false,
			info: '',
			sidebar_grid:false,
			position_x: 0,
        	position_y: 0,
			show_components: false,
			dialog_create_dashboard:false,
			name_dashboard: '',
			snackbar: false,
			color: 'success',
			is_new_dashboard: false,
			list_dashboards_profile:[],
			option_btn:[
				{
					action: 'setting',
					icon: 'mdi-cog',
					enable: true
				},
				{
					action: '',
					icon : 'mdi-list-bulled',
					enable: false
				}
			],
			dialog_option_comp: false,
			option_setting: [
				{
					text: 'Select type VideoStream',
					key: 'type_videostream',
					type: 'select',
					list: [
						'cam',
						'cam_test'
					]
				},
				{
					text: 'Init with streams',
					key: 'init_streams',
					type: 'select',
					list: [
						'Yes',
						'No'
					]
				},
				{
					text: 'Init with Analytic',
					key: 'type_analytic',
					type: 'select',
					list: [
						'motion',
						'event'
					]
				},
				{
					text: 'Type Stream',
					key: 'type_stream',
					type: 'select',
					list: [
						'udp',
						'event'
					]
				},
			],
			setting_dashboard: {
				type_videostream: 'cam_test',
				init_streams: 'Yes',
				type_analytic: 'motion',
				type_stream: 'udp',
			},
			list_paginations: [0],	
			paginate: [],				
			idx_layout: 0,
			btn_stream: false
		}), // data
		created(){
			// this.add_component('graphics');

		}, // created
		watch:{
			layout: function(v){
				// console.log('changeds', this.layout )
				let layout=this.layout;
				if (layout) {
					// let layout1 = JSON.stringify(layout)
	        		// localStorage.setItem('changed_profile_dashboard',layout1);
					// layout_t=v;
				}

			},
			sidebar_grid: function(v){
				if (!v) {
					let change=false;
					EventBus.$emit('components_menu_1', change);
				}
			}, // layout_side

		}, // watch
		methods:{
			actions(act){
				if (act == 'setting') {
					this.dialog_option_comp = true;
				}
				if (act == 'type_videostream') {
					console.log('changed ', act);
				}
			}, // action btn

			moveEvent_side: function(i, newX, newY){
		        console.log("MOVE sidebar i=" + i + ", X=" + newX + ", Y=" + newY);		    		    
		    },
		    moveEvent: function(i, newX, newY){
		        // console.log("MOVE i=" + i + ", X=" + newX + ", Y=" + newY);		        
		    },
		    movedEvent: function(i, newX, newY){
            	let msg = "MOVED i=" + i + ", X=" + newX + ", Y=" + newY;
	            // this.eventLog.push(msg);
	            let layout=this.layout;
					if (layout) {
						// let layout1 = JSON.stringify(layout)
		        		// localStorage.setItem('changed_profile_streaming',layout1);
						// layout_t=v;
					}				
            	// console.log(msg);
        	},
	        layoutCreatedEvent: function(newLayout){
	            this.eventLog.push("Created layout");
	            console.log("Created layout: ", newLayout)
	        },
	        layoutBeforeMountEvent: function(newLayout){
	            this.eventLog.push("beforeMount layout");
	            console.log("beforeMount layout: ", newLayout)
	        },
	        layoutMountedEvent: function(newLayout){
	            this.eventLog.push("Mounted layout");
	            console.log("Mounted layout: ", newLayout)
	        },
	        layoutReadyEvent: function(newLayout){
	            this.eventLog.push("Ready layout");
	            console.log("Ready layout: ", newLayout)
	        },
	        layoutUpdatedEvent: function(newLayout){
	            this.eventLog.push("Updated layout");
	            console.log("Updated layout: ", newLayout)
	        },
	        is_valid_ip(str){
				let verdad = str.split('.');
			    if(verdad.length != 4)
			      return false;
			    for(var i in verdad){
			      if(!/^\d+$/g.test(verdad[i])
			      ||+verdad[i]>255
			      ||+verdad[i]<0
			      ||/^[0][0-9]{1,2}/.test(verdad[i]))
			        return false;
			    }
			    return true;
			}, // is valid ip

			check_selects(v){ // check components in layout
				// console.log(sel, 'init check', v.length, v)
				let list=v;
				let sel=this.components;//list_components;
				for(let i in list){
					for(let j in sel){
						if (list[i].component==sel[j]) {							
							if (list[i].component!=='alerts' && list[i].component!=='constellation') {
								sel.splice(j, 1); // delete of components
							}
						}
					}
				}
				this.components=sel;
				// console.log(sel, 'chenck', v.length, v)
				//this.list_components=sel;
			},
	        check_data(layouts, list, type){
				// console.log('check data')
				// let list_hosts=this.list, list_rtsp=this.list_rtsp;
				let p_x=0, p_y=0, p_x1=0, p_y1=0;
				for (var i = 0; i < layouts.length; i++) {
					if (layouts[i].component=='cam' && layouts[i].stream_data) {
						let sw=true;
						for (var j = 0; j < list.length && sw==true; j++) {
							if(layouts[i].stream_data.host_id==list[j].id && layouts[i].stream_data.type==type){
								// console.log(layouts[i].stream_data.host_id, 'check item')
								
								let host_name='';
								
								if (list[j].host) {
									host_name= list[j].host.name
								}else{
									host_name=list[j].name;
								}


								if (host_name!==layouts[i].stream_data.hostname  ||
									list[j].ip!==layouts[i].stream_data.ip){
									// console.log(layouts[i].stream_data.hostname, 
									// 	layouts[i].stream_data.ip,
									// 	list[j].ip,  host_name, 'match check');
									layouts[i].stream_data.hostname=host_name;
									layouts[i].stream_data.ip=list[j].ip;
								}// if name
								sw=false;
							} // check stream data
						}// for check host
						
					}// check component
					if (layouts[i].component=='mapview' && type=='udp') {// update mapview
						layouts[i].stream_data=list;
					}
					if (layouts[i].x>p_x) {
						p_x1=layouts[i].x+layouts[i].w;
						p_x=layouts[i].x;
					}
					if (layouts[i].y>p_y) {
						p_y1=layouts[i].y;
						p_y=layouts[i].y;						
					}	
				} // for list
				this.layout=layouts;
				this.position_x=p_x1;
				this.position_y=p_y1;
				// console.log('check_data');
			},

			check_length(val){
				let layouts=this.layout;
				let num=0, sw=false, indx=0;
				for (let j = 0; j < layouts.length; j++) {
					if (layouts[j].i==val) {
						sw=true;
						// indx=layouts[j].i;
					}
					if (layouts[j].i>=indx) { // max value
						indx=layouts[j].i;
					}
				}
				if(sw){
					num=indx+1//layouts[layouts.length-1].i+1;
				}else{
					num=val;
				}
				return num;
				// this.layout[indx].i=num;
			}, // check lenght 

			del_render(v){
				let list_new=this.dashboards;
				for (let  i in list_new){
					// console.log(list_new[i].title ,'i , index')
					if (list_new[i].title==v) {
						// console.log(v, 'del')
						list_new.splice(i,1);
						break;
					}
				}
				return list_new;
			}, //del_render

			del_draw(val){
				let layout_temp=this.layout, list_component=this.components;
				for (let num in layout_temp){
					// console.log(num , layout_temp[num].Id, val, 'id_layout', layout_temp[num].component, layout_temp[num])
					if (layout_temp[num].Id===val) {
						// console.log(num , layout_temp[num].Id, val, 'id_layout', layout_temp[num].component)

						if (layout_temp[num].component=='events' || 
							layout_temp[num].component=='rfid' ||
							layout_temp[num].component=='match_history' ||
							layout_temp[num].component=='mapview' ||						
							layout_temp[num].component=='plate_search') 
						{
							/*for(var j of list_component){
								if (j==layout_temp[num].component) {		
									j.state=true;*/
									// console.log(j.text, j.state)
									// this.render_components;
								let components=list_component, sw=true; 
								for(var i in components){
									if (components[i].component==layout_temp[num].component) {
										sw=false;
									}
								}
								if (sw) {
									list_component.push(layout_temp[num].component);				
								}
							/*	}
							}*/
							
						} // if

						layout_temp[num].component = 'blank_component';
						// layout_temp.splice(num, 1); //this.layout.indexOf(val)

					}
				}// for
				this.layout=layout_temp;
				this.component=list_component;
				// return this.layout;
			}, // del
			add_component(item, index){
				// item.state=true;
				if (item!=='alerts') {
					this.components.splice(index, 1);
				}

				let layouts=this.layout, sw=true; 
				for(let i in layouts){
					if (layouts[i].component==item) {
						if (item !== 'alerts' && item !== 'constellation' && item !== 'blank_component') {
							sw=false;
						}
					}
				}
				if (sw) {
					this.add_draw(item)
				}
			}, 

				
			add_stream(item_stream, type, type_analytic){
				const { type_videostream } = this.setting_dashboard;				
				this.add_draw(type_videostream, item_stream, type, type_analytic);
			},


			add_draw(component, data, from, analytic='' ){


				let draw=[]; 
				let len_dash=this.layout.length+1, layout_items=this.layout, list_hosts=this.list, stream_data=[],len=0, x=0, y=0, w=20, h=10, min_h=10, min_w=20;
				


				if (len_dash == 9) {
					EventBus.$emit('notifications_modal', { 
						type: 'success', 
						message: 'Component added the last page or create a new page' 
					});

					if (component !== 'cam' && component !== 'cam_test' && component !== 'blank_component' ) {
						this.render_pagination( component , { data });
					}else{
						this.render_pagination( component , { 
							device: data, 
							type_stream: from, 
							type_analytic: analytic 
						});
					}
					
					
				}else{

					// console.log(component, from, 'draw');	
					
					// console.log(len, len_dash, 'length 1')
					//Component size defaults
					if (component=='events') {
						w=49;
						h=26;
						min_h=15;// 26
						min_w=49;
					}else if (component=='rfid') {
						w=64;
						h=19;
						min_h=12;//19
						min_w=64;
					}else if (component=='match_history') {
						w=94;
						h=23;
						min_h=10//23
						min_w=94;
					}else if(component=='mapview'){
						stream_data=list_hosts;
						w=30;
						h=15;
						min_h=15;
						min_w=10;
					}else if(component=='alerts'){
						w=52;
						h=17;
						min_h=15; //17
						min_w=52;
					}else if(component=='plate_search') {
						w=45;
						h=5;
						min_h=5;
						min_w=40;
					}else{

						// x w <<  120

						min_h = 4;//8;
						min_w = 7;//15;
					}
					let gw = 120 / 4;//this.$setting_grid.number_grids;
					let gh = (this.$vuetify.breakpoint.height * 0.02137);
					// console.log(gw, gh, 'gw, gh');
					w = gw;
					h = gh;

					// Components streams
					if (component == 'cam') {
						if (from == 'udp' || from == 'event') {				
							stream_data = {
								host 	 		: this.$localhost+':4550/',
								host_id  		: data.deviceId,
								hostname 		: data.name,
								name 	 		: "dashboard"+data.deviceId, // analytic ?   : "dashboard",
								type 	 		: from,
								info_cam 		: data, 
								name_analytic 	: analytic,
								// ip: data.ip
							};
						}else{
							let dt 		= '', 
								id_host = '';
							if(data.host){
								dt 		= data.host.name;
								id_host = data.host.id;
							}

							stream_data = {
								host 			: data.rtsp_stream,
								host_id 		: data.id,
								hostname 		: dt,
								name 			: "dashboard",
								type 			: "flv",
								ip 				: data.ip,
								show_host_id 	: id_host,
								info_cam 		: data,
							};
						}
					}
					if (component == 'cam_test') {
						stream_data={							
							host_id 	: data.deviceId,
							hostname 	: data.name,
							info_cam 	: data,
						}
					}

					// check spaces in layout
					// for (var i = 0; i < layout_items.length; i++) {

						//layout_items[len_dash].w+layout_items[len_dash].x;
						if (component == 'cam_test' || component == 'cam' || component == 'blank_component') {

							x=this.position_x;
							y=this.position_y;
							if (x <= 120) {
								x = this.position_x;
								this.position_x = x + w;
								// y=this.position_y;
								// this.position_y=layout_items[len_dash-1].w + y;
							}
							
							if (x >= 120) {
								x = 0;
								y = h + this.position_y; //layout_items[len_dash-1].
								this.position_y = y;
								this.position_x = x + w;
							}

						}else{

							// this.check_position_y();
							x = this.position_x;
							y = this.position_y;
							// console.log(x, y, w, h, 'componets else')
							if (x >= 80) {
								x = 0;
								y = h;
								this.position_y = y;
								this.position_x = x;

							}
							this.position_y = y;
							this.position_x = w;							
							
						}
							// console.log(x, w, x+w, 'position x')
						// if (x>120){ // || (x>90 && w>30) || x+w>120 
						// 	x=0;						
						// 	y=layout_items[len_dash].h;
						// 	console.log('break')

						// }
						
					// }
					// console.log(len, len_dash, 'length 2')
					if (from == 'sidebar') {					
						len = len_side;
						y = 0;
						w = 6;
						h = 1;
					}else{
						len = len_dash;
						x = x;
						y = y;
						w = w;
						h = h;
					}
					// console.log(len, len_dash, 'length 3')
					// console.log(x, y, 'x, y ')
					if(!stream_data){
						stream_data = null;
					}
					len = this.check_length(len);
					// console.log(len, 'length 4')
					draw = {
						x 		: x,
						y 		: y,
						w 		: w,
						h 		: h,
						i 		: len,
						Id 		: len + component,
						state 	: true,
						minW 	: min_w,
	            		minH 	: min_h,
						component : component,
						'stream_data' : stream_data,
						static 	: true,
					}
					
					this.layout.push(draw);
						
					
						// console.log("this.layout", this.layout);
						// console.log("draw", draw);
				}
			}, // add_draw
			render_devices(){					
				let list_analytic = analytic_list;
				if (localStorage.getItem('list_devices')) {
					const list_temp = JSON.parse(localStorage.getItem('list_devices'));
					let vm 		= this;
					let check 	= true;
					vm.list 	= list_temp;

					if (!this.list_paginations) {
						check = false;
					}
					// let device= {deviceId : "246a5493-5ee3-4aef-8b3e-612372d33a2f"}
					// vm.add_stream(device, 'event', 'motion');
					const { init_streams, type_stream, type_analytic , type_videostream} = this.setting_dashboard;				
					if (init_streams == 'Yes' && check) {						
						if (this.layout.length == 0) {	
							list_temp.forEach( function (device, idx_device, len_device) {
								if (device.deviceId) {
									// console.log(device, 'info device dashboard');	
									if (idx_device < 8) {
										vm.add_stream(device, type_stream, type_analytic);
										vm.render_pagination( type_videostream, { device, type_stream, type_analytic })
									}else{
										vm.render_pagination( type_videostream, { device, type_stream, type_analytic })
									}
									/*list_analytic.forEach( function(item_analytic, idx_analytic){
										if (item_analytic.active_dashboard) {
											vm.add_stream(device, 'udp', item_analytic.key);		
										}
									})*/
								}
							})

						}
					}

					this.$emit('status_steps', this.$ml.get('loaded_devices_list'));
		      		this.$emit('status_steps', false);
				}
			}, // render devices

			render_pagination(opt, item, idx){				
			
				// console.log(opt, item, 'info to paginate')
				let pg 		= 0;
				let index 	= 0;
				this.paginate.push({									
					component: opt, 
					info: item,
				})
				let list_temp = this.paginate;
				pg = list_temp.length;

				if (pg < 9) {
					let len = this.list_paginations.length;
					// let list_temp = this.paginate;
					
					
				 	this.list_paginations[len - 1] = list_temp; 
					if (pg == 8) {
						this.paginate = [];
						this.list_paginations[len] = list_temp;
						// console.log(this.list_paginations.length, 'len list', this.list_paginations);
					}
					EventBus.$emit('pagination', this.list_paginations);

				}
				const timer_render = setTimeout(()=>{

					if (this.layout.length < 8) {
						let len = this.layout.length;
						if (len < 8) {
			        			console.log(8 - len , 'len fault')
			        			let fault = 8 - len;
			        			let i = 1;
			        			this.idx_layout = fault;
			        			while (i < fault+1){
			        				// console.log('adding blank_component', i);
			        				this.add_component('blank_component');
			        				i++
			        			}
			        		}
					}
				}, 1000)

			}, // render pagination

	        render_pages(item){
	        	let list = this.list_paginations;

	        	if (item) {
	        		// this.layout 	= null;
	        		this.layout 	= [];
	        		let pg 			= item;
	        		let list_temp 	= list[pg];
	        		let vp 			= this;
	        		let len 		=  list_temp && list_temp.length ? list_temp.length : 0 ;
	        		this.pages 
	        		this.current_page = pg;	        		

	        		const { init_streams, type_stream, type_analytic , type_videostream} = this.setting_dashboard;
	        		this.position_x = 0;
	        		this.position_y = 0;

	        		if (list_temp && len > 0) {
	        			const time_render = setTimeout( ()=> {

			        		list_temp.forEach( function (arr_pg, idx_pg, len_pg) {	
			        			if (arr_pg.component) {
									// console.log(device, 'info device dashboard');
									if (len_pg == 8) {
										vp.idx_layout = 8;
									}	
									if (idx_pg < 8) {


										if (arr_pg.info && arr_pg.info.device && arr_pg.info.device.deviceId &&
											(arr_pg.component == 'cam' ||
											arr_pg.component == 'cam_test' ||  arr_pg.component == 'blank_component'  )) {

											vp.add_stream(arr_pg.info.device, 
												arr_pg.info.type_stream,
												arr_pg.info.type_analytic
											);
										}else{
											vp.add_component(arr_pg.component, arr_pg.info);
										}
									}
								}
							})

							console.log(list_temp, 'page')
			        		if (len < 9 && this.layout.length < 8) {
			        			console.log(8 - len , 'len fault')
			        			let fault = 8 - len;
			        			let i = 1;
			        			this.idx_layout = fault;
			        			while (i < fault+1){
			        				// console.log('adding blank_component', i);
			        				this.add_component('blank_component');
			        				i++
			        			}
			        		}
							clearTimeout(time_render);
	        			}, 500); // settimeout
	        		} // if
	        		
	        	}
	        }, // render pages

			text_length(text){
    			if (text.length>23) {
    				return true
    			}
    			return false
    		}, // text length

    		change_stream_type(item_change, type){
    			console.log(item_change, 'info to renders',item_change.Id)

    			let ID=item_change.Id;
    			let layout_temp=this.layout;
    			for (let num in layout_temp){
					if (layout_temp[num].Id===ID) {
						if (layout_temp[num].stream_data) {

						console.log("layout_temp[num].stream_data", layout_temp[num].stream_data);
							if (type == 'stream') {
								layout_temp[num].stream_data.type=item_change.new_val; // type stream
							}else{
								layout_temp[num].stream_data.name_analytic=item_change.new_val; // type analytic
							}
						}
						// console.log(layout_temp[num].stream_data.type, 'layout to renders')
					}
				}// for
				this.layout=layout_temp;
				this.update_changed_layout();
    		}, // change stream type


    		update_changed_layout(lay){
    			let layout=this.layout;
				if (layout) {
					let layout1 = JSON.stringify(layout)
	        		localStorage.setItem('changed_profile_streaming',layout1);
	        		// console.log('updated layout')
					// layout_t=v;
				}
    		}, // update change layout

    		        create_dashboard(is_new=''){
        	if (is_new=='create') {

	        	axios.defaults.withCredentials=true;
	        	var api='';
	        	axios.post().then(response => {
	        		this.info='Dashboard Created';
	        		this.color="success";
	        		this.snackbar=true;
	        		this.dialog=false;
	        	}).catch( error => {
	        		this.info='Dashboard Error';
	        		this.color="error"
	        		this.snackbar=true;
	        	})
        	}else{
        		// create profile dashboard
        		let layout_temp=this.layout, 
        		name_profile=this.name_dashboard;
        		let layout_change=this.list_dashboards_profile.layout_saved;
        		let name_check=null;
        		let options1={
			    	draggable: this.draggable,
					resizable: this.resizable,
					vertical_compact: this.vertical_compact,
					prevent_collision: this.prevent_collision,
					responsive: this.responsive
			    }
        		if (this.list_dashboards_profile.names_profiles) {
        			name_check=this.list_dashboards_profile.names_profiles;
        		}
        		// console.log(layout_temp, this.layout,' check layout')
        		if (layout_temp.length==0) {
        				this.color='warning';
        				this.info='Dashboard empty, Please add components';
        				this.snackbar=true;
        				this.dialog_create_dashboard=false;

        		}else{
	        		let item={ name: name_profile , layout: layout_temp, opts:options1 }, sw=false;	        		
	        		if(layout_change){
						layout_change.forEach( function (val, i) {							
							if (val.name==name_profile && is_new=='profile') {
								sw=true;
							}

							if (val.name==name_check && is_new=='update') {
								val.name=item.name; // layout_change
								val.layout=item.layout; // layout_change
								val.opts=options1; // layout_change
								
							}
						})      
						if (sw) {
							this.color='warning';
	        				this.info=this.$ml.get('ms_name_exist');
	        				this.snackbar=true;
						}  			
	        		}else{
	        			layout_change=[];
	        		} // check names

	        		
	        		if (sw==false) {
	        			if (is_new=='profile') {	        				
	        				layout_change.push(item);
	        			}
	        			
						const layouts_list = JSON.stringify(layout_change);      				
			        	localStorage.setItem('list_dashboard_profiles',layouts_list);
			        	this.color='success';
        				this.info=this.$ml.get('saved');
        				this.snackbar=true;
        				this.dialog_create_dashboard=false;
        				EventBus.$emit('refresh_profiles_dashboard');
	        		}
        		} // if check layout
        	}

        }, // create dashboard

	        save_local(opt){

	        	if (opt=='setting_streaming') {
	        		const to_local = JSON.stringify(this.setting_dashboard);
	        		localStorage.setItem(opt, to_local);
	        		this.dialog_option_comp = false;
	        	}
	        	
	        	EventBus.$emit('notifications_modal', { 
	        		type: 'saved',
	        		message: opt
	        	})
	        }, // save local
	        
	        get_local(){
	        	if (localStorage.getItem('setting_streaming')){
	        		const local_temp = JSON.parse(localStorage.getItem('setting_streaming'));
	        		this.setting_dashboard = local_temp;
	        	}
	        }, // get local

	        get_local_paginations(){
	        	if (localStorage.getItem('pagination_layout')) {
	        		const temp = JSON.parse(localStorage.getItem('pagination_layout'));
	        		this.list_paginations = temp;
	        		EventBus.$emit('pagination', temp);
	        	}
	        },

	        change_stream(item){ // for replace blank component to stream
	        	if (item) {

	        	}	
	        }, // change stream

		}, // methods
		mounted(){
/*				let loaded_host=false;
			if (this.list.length==0) {
				let loading_host=setTimeout( () =>{
					// this.$emit('status_steps', this.$ml.get('loading_hosts_list'));
					// this.get_num_host();
					loaded_host=true;
				}, 5000) 
				if (loaded_host) {
					// clearTimeout(loading_host);
				}
			}*/
			
			// get paginatess
			this.get_local_paginations();
			// get setting streaming
			this.get_local();

			let loaded_devices=false;					 	
			let loading_devices=setTimeout(() => {								

				this.$emit('status_steps', this.$ml.get('loading_devices_list'));
				// charge paginations and videos
				this.render_devices();
				loaded_devices=true;
								
				console.log('clear setTimeout', this.list_rtsp);					
				
			}, 2000) 
			
			//if (loading_devices) {				}
			// this.$emit('status_steps', this.$ml.get('loading_dashboard_profile'));
			/*let loaded_layouts=false;			
			if (this.layout.length==0) {	
				let loading_layouts=setTimeout( () => {

				 	if (localStorage.getItem('changed_profile_streaming')) {		
				    	this.layout=JSON.parse(localStorage.getItem('changed_profile_dashboard')); 	
				    	if (this.layout && this.layout.length>0) {
				    		this.check_selects(this.layout);
				    		// this.$emit('status_steps', this.$ml.get('loaded_streaming_profile'));
				    		this.$emit('status_steps', false);
				    		loaded_layouts=true;
				    	}	    
				    	
				    }
				}, 3000);
				if (loaded_layouts) {
					console.log('close loadings layouts');
					// clearTimeout(loading_layouts);
				}
			}*/

			if (this.count) { // (list_new.length===0) && 
				this.info=this.$ml.get('ms_adh');
				EventBus.$emit('show_op', true );
			}			

			EventBus.$on('profile', (actions) =>{
				console.log(actions, 'profile dashboard')
				if (actions.update) {
					this.dialog_create_dashboard=actions.update;
					this.name_dashboard=actions.name;
					this.list_dashboards_profile={names_profiles:actions.name, layout_saved: actions.item_profile };
					this.is_new_dashboard='update'
					
				}else{
						console.log(actions, 'recibe profile')
						// alert(actions)
					if (actions) {
						if (actions.layout) {
							this.layout=actions.layout;
						}
						// if (actions.options) {
						// 	let opt=actions.options;
						// 		this.draggable=opt.draggable;
						// 		this.resizable=opt.resizable;
						// 		this.vertical_compact=opt.vertical_compact;
						// 		this.prevent_collision=opt.prevent_collision;
						// 		this.responsive=opt.responsive;
						// }
						this.check_selects(this.layout);
						this.check_data(this.layout, this.list, 'udp');
					}else{
						this.layout=[];
					}
				}
			});
			EventBus.$on('save_profile', (names_profiles, layout_saved) =>{ 
				this.list_dashboards_profile={names_profiles, layout_saved};
				this.dialog_create_dashboard=true;
				this.is_new_dashboard='profile';
				this.name_dashboard='';

			})

			// drawable options
			EventBus.$on('drawable_dashboard', (actions)=>{ 


			    this.grid_options[actions.option]=actions.active;
			    console.log('save_options draggable', actions );
			    let options1=this.grid_options;
			    /*{
			    	draggable: this.draggable,
					resizable: this.resizable,
					vertical_compact: this.vertical_compact,
					prevent_collision: this.prevent_collision,
					responsive: this.responsive
			    }*/
			    
				const options_draggs = JSON.stringify(options1);
				localStorage.setItem('options_draggable_streaming',options_draggs);
			    
			});
		

	    	if (localStorage.getItem('options_draggable_streamings')) {
	    		console.log('options draggables toolbar')
	    		let options_set=JSON.parse(localStorage.getItem('options_draggable_streamings'));
	   //  		this.draggable=options_set.draggable;
				// this.resizable=options_set.resizable;
				// this.vertical_compact=options_set.vertical_compact;
				// this.prevent_collision=options_set.prevent_collision;
				// this.responsive=options_set.responsive;
				EventBus.$emit('options_set_draggable_streamings', options_set)
		    }

			EventBus.$on('components_menu', (actions )=> {
		    	this.sidebar_grid=actions;
		    });


		    EventBus.$on('page', (action) => {
		    	console.log('page', action)
		    	this.render_pages(action);
		    });
		}, // mounted
	};
</script>